import React, { useMemo } from 'react'
import { FilterConfig } from '../../../models/FilterConfig'
import FilterComponent from '.'

type Props = {
    config: FilterConfig[],
    data: any,
    handleFilterValueChange: (key: string, value: string | string[]) => void,
    values?: Record<string, string[] | string>
}
const FilterComponentCreator = ({ config, data, handleFilterValueChange, values }: Props) => {
    const dropDowns = useMemo(() => {
        return config.reduce<{ [key: string]: SelectDropDown[] }>((acc, { apiKey, filterLabelKey, filterValueKey }) => {
            acc[apiKey] = data?.[apiKey]?.map((options: any) => ({ label: options?.[filterLabelKey], value: options?.[filterValueKey] }))
            return acc;
        }, {});
    }, [data])
    return (
        <>
            {config.map(({ filterName, apiKey, type, payloadValuekey, cleanable = true }) => {
                let value: string[] | undefined = undefined;
                if (values && Object.hasOwn(values, payloadValuekey)) {
                    const payload = values[payloadValuekey];
                    value = Array.isArray(payload) ? payload : [payload];
                }
                return (
                    <FilterComponent
                        key={apiKey}
                        filterName={filterName}
                        labelKey="label"
                        valueKey="value"
                        type={type}
                        options={dropDowns?.[apiKey] || []}
                        onFilterChange={(value: string) => {
                            handleFilterValueChange(payloadValuekey, value);
                        }}
                        value={value}
                        cleanable={cleanable}
                    />
                )
            })}
        </>
    )
}

export default FilterComponentCreator